import React from 'react';
import { Transition } from '@headlessui/react';
import {
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XMarkIcon,
} from '@heroicons/react/24/solid';
import { useNotificationStore, NotificationType } from '../hooks/useNotificationStore';

const iconMap: Record<NotificationType, React.ElementType> = {
  success: CheckCircleIcon,
  error: XCircleIcon,
  warning: ExclamationTriangleIcon,
  info: InformationCircleIcon,
};

const colorMap: Record<NotificationType, string> = {
  success: 'text-green-400',
  error: 'text-red-400',
  warning: 'text-yellow-400',
  info: 'text-blue-400',
};

export default function ToastContainer() {
  const { notifications, removeNotification } = useNotificationStore();

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2 max-w-sm">
      {notifications.map((notification) => {
        const Icon = iconMap[notification.type];
        return (
          <Transition
            key={notification.id}
            show={true}
            appear={true}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0"
            enterTo="translate-y-0 opacity-100"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="bg-surface-800 border border-surface-700 rounded-lg shadow-lg p-4 flex items-start gap-3">
              <Icon className={`w-5 h-5 ${colorMap[notification.type]} flex-shrink-0 mt-0.5`} />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-surface-100">{notification.title}</p>
                {notification.message && (
                  <p className="text-sm text-surface-400 mt-1">{notification.message}</p>
                )}
              </div>
              <button
                onClick={() => removeNotification(notification.id)}
                className="text-surface-500 hover:text-surface-300"
              >
                <XMarkIcon className="w-4 h-4" />
              </button>
            </div>
          </Transition>
        );
      })}
    </div>
  );
}
